export default __webpack_public_path__ + "media/images/rowhover-test-f03e25d2211cd567a1359a9e1c3fdfad.png";